import CognitoClient from '@mancho.devs/cognito';
import { Observable, from, of } from 'rxjs';
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { CognitoUserSession, CognitoUserPool } from 'amazon-cognito-identity-js';
import { ofType } from 'redux-observable';

//local dependencies
import {
   LoginAction,
   LoginActionTypes,
   signUpFailed,
   signUpSucceeded,
   confirmCodeSucceeded, confirmCodeFailed,
   SignUpRequest,
   ConfirmCodeRequest,
   SignInRequest,
   signInSucceeded,
   signInFailed,
   ForgotPasswordRequest,
   forgotPasswordSucceeded,
   forgotPasswordFailed,
   ConfirmPasswordRequest,
   confirmPasswordSucceeded,
   confirmPasswordFailed,
   signOutSucceeded,
   signOutFailed,
   GetSessionAction,
   getSessionFailed,
   getSessionSucceeded
} from './authAction';

const cognitoClient = new CognitoClient({
   UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
   ClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
});
const userPool = new CognitoUserPool({
   UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID!,
   ClientId: process.env.GATSBY_COGNITO_CLIENT_ID!,
});

export function signUpEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.SIGNUP_REQUEST),
      switchMap(({ payload: { email, password } }: SignUpRequest) =>
         cognitoClient.signUp(email, password).then(signUpSucceeded).catch(signUpFailed),
      ),
   );
}

export function confirmCodeEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.CONFIRM_CODE_REQUEST),
      switchMap(({ payload: { email, code } }: ConfirmCodeRequest) =>
         cognitoClient.signUpConfirmCode(email, code).then(confirmCodeSucceeded).catch(confirmCodeFailed),
      )
   )
}

export function signInEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.SIGNIN_REQUEST),
      switchMap(({ payload: { email, password } }: SignInRequest) =>
         cognitoClient.signIn(email, password).then(signInSucceeded).catch(err => {
            let myMessage = '';
            if (err.code === "UserNotFoundException") {
               myMessage = "Такого пользователя не существует";
            } else {
               myMessage = "Произошла ошибка при входе";
            }
            return (signInFailed(myMessage))
         }
         )
      ),
   );
}

export function forgotPasswordEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.FORGOT_PASSWORD_REQUEST),
      switchMap(({ payload: { email } }: ForgotPasswordRequest) =>
         cognitoClient.forgotPassword(email).then(forgotPasswordSucceeded).catch(forgotPasswordFailed),
      ),
   );
}

export function confirmPasswordEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.CONFIRM_PASSWORD_REQUEST),
      switchMap(({ payload: { email, code, newPassword } }: ConfirmPasswordRequest) =>
         cognitoClient.confirmPassword(email, code, newPassword).then(confirmPasswordSucceeded).catch(confirmPasswordFailed),
      ),
   );
}

export function signOutEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      filter((action: LoginAction) => action.type === LoginActionTypes.SIGN_OUT_REQUEST),
      switchMap(() =>
         cognitoClient.signOut().then(signOutSucceeded).catch(signOutFailed)
      )
   )
}

export function getSessionEpic(action$): Observable<LoginAction> {
   return action$.pipe(
      ofType(LoginActionTypes.GET_SESSION),
      filter(() => typeof window !== 'undefined'),
      mergeMap(() =>
         from(getSessionPromise()).pipe(
            map((session) => {
               const accessToken = session.getAccessToken().getJwtToken();
               const refreshToken = session.getRefreshToken().getToken();
               const idToken = session.getIdToken().getJwtToken();
               const email = session.getIdToken().decodePayload()?.email;

               localStorage.setItem('accessToken', accessToken);
               localStorage.setItem('refreshToken', refreshToken);
               localStorage.setItem('idToken', idToken);

               return getSessionSucceeded(email, session);
            }),
            catchError((error) => of(getSessionFailed(error))),
         )
      )
   );
}
function getSessionPromise(): Promise<CognitoUserSession> {
   return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();

      if (!user) {
         reject(new Error('No current Cognito user'));
         return;
      }

      user.getSession((error, session) => {
         if (error) {
            reject(error);
         } else if (!session) {
            reject(new Error('No session'));
         } else {
            resolve(session);
         }
      });
   });
}